<div class="pos-relative page-content" style="height: 95%;">
    <app-scheduler-form (onScheduleAfterSave)="onAfterSave($event)" (onLoad)="onLoadForm()"></app-scheduler-form>
</div>
